module.exports = __webpack_public_path__ + "static/media/illustration_george_business_app.d67610aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration_george_business_app.png
// module id = 339
// module chunks = 21